import { code, flag } from 'country-emoji';

let regionNamesInEnglish = null;
let languageNamesInEnglish = null;
try {
  regionNamesInEnglish = new Intl.DisplayNames(['en'], { type: 'region' });
  languageNamesInEnglish = new Intl.DisplayNames(['en'], { type: 'language' });
} catch {
  // Intl.DisplayNames may not be available in all environments (e.g. Cypress Electron).
  // Functions below fall back to returning raw codes when these are null.
}

export function getCountryName(countryCode) {
  if (!regionNamesInEnglish) return countryCode;
  let countryName;
  try {
    countryName = regionNamesInEnglish.of(countryCode);
  } catch {
    countryName = countryCode;
  }
  return countryName;
}

export function getCountryFlag(countryNameOrCode) {
  const countryFlag = flag(countryNameOrCode);
  return countryFlag || '-';
}

export function getCountryCode(countryNameOrFlag) {
  const countryCode = code(countryNameOrFlag);
  return countryCode || '-';
}

export function getLanguageName(languageCode) {
  if (!languageNamesInEnglish) return languageCode;
  let languageName;
  try {
    languageName = languageNamesInEnglish.of(languageCode);
  } catch {
    languageName = languageCode;
  }
  return languageName;
}
